import { Button } from "../buttons/Button";
import Icon from "../Icon";
import { ReuseDisplay } from "./ReuseDisplay";

import "../../styles/reuse/reuseControl.css";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";

export { ReuseControl };

type Props = {
  generatingReuse: boolean;
  extractedData: {
    // get index of current extracted
    getIndex: () => number;
    // get other reuse options
    getReuse: () => Array<any>;
  };
  changeToReuse: (index: number) => void;
  generateReuse: VoidFunction;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const ReuseControl = (props: Props) => {
  const currentExtractedValueIndex = props.extractedData.getIndex();

  // NEW CODE
  if (props.generatingReuse || props.extractedData.getReuse().length <= 1) {
    return (
      <Button
        data-generate-reuse
        className={"reuseControl white"}
        {...props.tProps}
        // className={'reuseControl'}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => props.generateReuse()}
        disabled={props.generatingReuse}
      >
        {`${props.generatingReuse ? "Generating" : "Generate"} Reuse`}
      </Button>
    );
  }

  return (
    <div data-choose-reuse className={`reuseControl`} {...props.tProps}>
      <span
        className={"reuseButtons"}
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Button
          className={"white"}
          onClick={() => props.changeToReuse(currentExtractedValueIndex - 1)}
        >
          <Icon altText={"Previous Reuse Value"} icon={"angle-left"} />
        </Button>

        <ReuseDisplay
          key={currentExtractedValueIndex}
          extractedData={props.extractedData}
        />

        <Button
          className={"white"}
          onClick={() => props.changeToReuse(currentExtractedValueIndex + 1)}
        >
          <Icon altText={"Next Reuse Value"} icon={"angle-right"} />
        </Button>
      </span>
    </div>
  );
};
